// src/components/common/MobileSidePanel.jsx
// 모바일 사이드 패널
import React, { useEffect } from "react";

const MobileSidePanel = ({
  isOpen,
  onClose,
  title,
  headerActions,
  footer,
  scrollable = true,
  closeOnOverlay = true,
  className = "",
  children,
}) => {
  // ESC로 닫기
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, onClose]);

  // 바디 스크롤 잠금
  useEffect(() => {
    if (isOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        aria-hidden
        onClick={closeOnOverlay ? onClose : undefined}
        className={`fixed inset-0 bg-black/50 z-40 transition-opacity ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        style={{ zIndex: 40 }}
      />

      {/* Bottom Sheet */}
      <div
        className={`fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-2xl z-50 transform transition-transform duration-300 ease-out ${isOpen ? "translate-y-0" : "translate-y-full"
          } ${className}`}
        style={{
          maxHeight: "90vh",
          zIndex: 50,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* 헤더 */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
          <div className="flex-1 min-w-0" style={{ minWidth: 0, maxWidth: '100%', boxSizing: 'border-box', overflow: 'hidden' }}>
            {typeof title === "string" ? (
              <h3 className="text-base font-semibold text-gray-900 truncate" style={{ fontSize: '1rem', lineHeight: '1.5rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {title}
              </h3>
            ) : (
              title
            )}
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            {headerActions}
            <button
              onClick={onClose}
              className="p-2 text-gray-400 hover:text-gray-600 rounded-lg hover:bg-gray-100"
              style={{ padding: '0.5rem' }}
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* 컨텐츠 */}
        <div
          className={`${scrollable ? "overflow-y-auto" : ""} min-w-0`}
          style={{
            maxHeight: "calc(90vh - 120px)",
            width: '100%',
            maxWidth: '100%',
            boxSizing: 'border-box',
          }}
        >
          <div className="p-4 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
            {children}
          </div>
        </div>

        {/* 푸터 */}
        {footer && (
          <div className="p-4 border-t border-gray-200 min-w-0" style={{ width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
            {footer}
          </div>
        )}
      </div>
    </>
  );
};

export default MobileSidePanel;

